module.exports = __webpack_public_path__ + "media/images/program/sos_stress_triangle-b47d066743fbfb27c3b513dca9fec84c70818f2ed97a8bc516e01e6f5ace8d16.png";